import { createSelector } from '@reduxjs/toolkit';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';
import { employeesForStaffingCalendar } from '../staffing/employees-for-staffing-calendar';

export const currentEmployeeForStaffingCalendar = createSelector(
  employeesForStaffingCalendar,
  currentEmployeeUuid,
  (employees, currentEmployeeUuid) => {
    return employees.find((e) => e.uuid === currentEmployeeUuid);
  },
);
